import { toast as baseToast, type ToastOptions } from "react-toastify";

/**
 * Nawy Now toasts anchor BOTTOM-LEFT (product ask, 2026-08-04): the flow's work area — the loan
 * process board, the step forms, the modals — lives on the right/top of the lead page, so a
 * top-right toast covers exactly what the agent is acting on. Position is pinned per-toast so the
 * rest of the CRM keeps the global container's default; import this instead of react-toastify
 * anywhere inside the module.
 */
const NAWY_NOW_TOAST: ToastOptions = { position: "bottom-left" };

export const toast = {
  success: (message: string, options?: ToastOptions) =>
    baseToast.success(message, { ...NAWY_NOW_TOAST, ...options }),
  error: (message: string, options?: ToastOptions) =>
    baseToast.error(message, { ...NAWY_NOW_TOAST, ...options }),
  info: (message: string, options?: ToastOptions) =>
    baseToast.info(message, { ...NAWY_NOW_TOAST, ...options }),
  warn: (message: string, options?: ToastOptions) =>
    baseToast.warn(message, { ...NAWY_NOW_TOAST, ...options }),
};
